import {
  fetchAiVideoIds,
  generatePreviewStreamUrl,
  generateStreamUrl,
} from '../queries/ai-video.queries'

import { useQuery } from '@tanstack/react-query'

export const useVideoIds = (storeId: string) =>
  useQuery<string[], Error>({
    queryKey: ['videoIds', storeId],
    queryFn: () => fetchAiVideoIds(storeId),
    refetchOnWindowFocus: false,
  })

export const useAiVideoUrl = (storeId?: string, videoId?: string | null) =>
  useQuery<string | undefined, Error>({
    queryKey: ['ai-video-url', storeId, videoId],
    queryFn: () => generateStreamUrl(storeId, videoId ?? ''),
  })

export const useAiPreviewVideoUrl = (storeId: string | null, videoId: string | null) =>
  useQuery<string | null, Error>({
    queryKey: ['ai-video-preview-url', storeId, videoId],
    queryFn: () => generatePreviewStreamUrl(storeId, videoId ?? ''),
  })
